import { singleton, inject } from "tsyringe";

// shared
import { convertStudentGradeCode } from "@/shared/utils/formatter";

// entities
import type { StudentDto } from "@/entities/user/models/dtos";
import { UserBehavior } from "@/entities/user/models/behaviors/UserBehavior";

// features
import { ReadOnlyInputFormConverter } from "@/features/pending-registration/models/converter/ReadOnlyInputFormConverter";
import type { ReadOnlyStudentInformationInputValue } from "@/features/pending-registration/models/interface";

@singleton()
export class ReadOnlyStudentInputFormConverter extends ReadOnlyInputFormConverter {
    constructor(@inject(UserBehavior) userBehavior: UserBehavior) {
        super(userBehavior);
    }

    // 오버로딩: null/undefined를 허용하는 안전한 버전
    public convert(studentDto: StudentDto | null | undefined): ReadOnlyStudentInformationInputValue;
    // 부모 클래스와 호환되는 버전
    public override convert(studentDto: StudentDto): ReadOnlyStudentInformationInputValue;
    public override convert(
        studentDto: StudentDto | null | undefined,
    ): ReadOnlyStudentInformationInputValue {
        // studentDto가 없으면 안전한 기본값 반환
        if (!studentDto) {
            return {
                id: "",
                type: "",
                name: "",
                email: "",
                birthday: "",
                phone: {
                    countryCode: "",
                    subscriberNumber: "",
                },
                location: "",
                grade: "",
                school: "",
                address1: "",
                address2: "",
                parentName: "",
                parentPhone: "",
            };
        }

        const supterResult = super.convert(studentDto);

        const superResult: ReadOnlyStudentInformationInputValue = {
            ...supterResult,
            school: studentDto.school.name,
            grade: convertStudentGradeCode(studentDto.grade),
            address1: "",
            address2: "",
            parentName: "",
            parentPhone: "",
        };

        if (studentDto.address) {
            superResult.address1 = studentDto.address.value1;
            superResult.address2 = studentDto.address.value2 || "";
        }

        if (studentDto.parentName) {
            superResult.parentName = studentDto.parentName;
        }

        if (studentDto.parentPhoneNumber) {
            superResult.parentPhone = studentDto.parentPhoneNumber.subscriberNumber;
        }

        return superResult;
    }
}
